import { makeAutoObservable } from "mobx"

export default class InsightUpload {

  constructor(insightUpload = {}) {
    this.id = insightUpload.id
    this.fileName = insightUpload.file_name
    this.url = insightUpload.url
    this.fileType = insightUpload.file_type

    makeAutoObservable(this)
  }
}
